import { Search } from 'lucide-react';
const schedulingFilters = [
    { value: '', label: 'Todos' },
    { value: 'available', label: 'Liberados' },
    { value: 'blocked', label: 'Bloqueados' },
];

export const FilterClient = ({
                                 search,
                                 setSearch,
                                 atendenteId,
                                 setAtendenteId,
                                 atendentes,
                                 loadingAtendentes,
                                 selfSchedulingStatus,
                                 setSelfSchedulingStatus,
                             }: any) => {
    return <div className="cli-filters">
        <label className="sf-search">
            <Search aria-hidden />
            <input
                type="search"
                placeholder="Buscar nome, e-mail ou telefone"
                aria-label="Buscar nome, e-mail ou telefone"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
        </label>
        {atendentes.length > 1 && (
            <select
                className="sf-select-field"
                value={atendenteId}
                onChange={(e) => setAtendenteId(e.target.value)}
                disabled={loadingAtendentes}
                aria-label="Filtrar por atendente"
            >
                <option value="">Todos os atendentes</option>
                {atendentes.map((a: any) => (
                    <option key={a.uid} value={a.uid}>
                        {a.displayName || a.email}
                    </option>
                ))}
            </select>
        )}
        <div className="sf-segmented" role="group" aria-label="Filtrar por autoagendamento">
            {schedulingFilters.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    aria-pressed={selfSchedulingStatus === option.value}
                    onClick={() => setSelfSchedulingStatus(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    </div>
}
